export const LaunchFormIcon = () => (
    <svg className="w-8 h-8" viewBox="0 0 56 64">
        <g transform="translate(1.000000, 1.000000)">
            <g transform="translate(0.000000, 7.000000)">
                <path fill="none" stroke="#fff" strokeWidth="1.5" d="M42,47.1V53c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2
                    c0-1.1,0.9-2,2-2h9.9"/>
                <path fill="none" stroke="#fff" strokeWidth="1.5" d="M7,13h5"/>
                <path fill="none" stroke="#fff" strokeWidth="1.5" d="M7,22h5"/>
                <path fill="none" stroke="#fff" strokeWidth="1.5" d="M7,29h5"/>
                <path fill="none" stroke="#fff" strokeWidth="1.5" d="M7,38h5"/>
                <path fill="none" stroke="#fff" strokeWidth="1.5" d="M7,44h5"/>
            </g>
            <g transform="translate(12.000000, 0.000000)">
                <path fill="none" stroke="#fff" strokeWidth="1.5" d="M42,14.1V52c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2
                    c0-1.1,0.9-2,2-2h23.9L42,14.1L42,14.1z"/>
                <path fill="none" stroke="#fff" strokeWidth="1.5" d="M42,14.9H28c-1.1,0-2-0.9-2-2V1"/>
                <path fill="none" stroke="#fff" strokeWidth="1.5" d="M7,13h13"/>
                <path fill="none" stroke="#fff" strokeWidth="1.5" d="M7,22h28"/>
                <path fill="none" stroke="#fff" strokeWidth="1.5" d="M7,29h28"/>
                <path fill="none" stroke="#fff" strokeWidth="1.5" d="M7,38h28"/>
                <path fill="none" stroke="#fff" strokeWidth="1.5" d="M7,44h28"/>
            </g>
        </g>
    </svg>
);
